import type { PreviewNotes } from "~types/types";

export const PREVIEW_NOTES: PreviewNotes = {
    curationName: "Opinion",
    description:
        "This package requires content with bylines, it will render with a light blue background.",
    links: [
        {
            name: "Figma",
            url: "https://www.figma.com/design/gMELOCd5MiIqECTbVITX8y/Homepage?node-id=1559-6995&m=dev",
        },
    ],
};
